export default "__VITE_ASSET__aYEHe2ZS__"